import * as React from "react";

import styled from "../../theme/styled";
import DynamicImage from "../dynamic-image";
import {
  IFieldTechnicalArticle,
  IFieldTechnicalArticleColumnType
} from "./field-technical-article";

interface IProps {
  type: IFieldTechnicalArticleColumnType;
  content: IFieldTechnicalArticle;
}

interface IParagraphImageFullWidthWrapper {
  className: string;
  type: IFieldTechnicalArticleColumnType;
}

const ParagraphImageFullWidthWrapper = styled<
  IParagraphImageFullWidthWrapper,
  "div"
>("div")`
  .content-container {
    .content-wrapper {
      .image {
        padding-top: 8%;
        width: 100%;

        &:first-child {
          padding-top: 0;
        }
      }
    }
  }
`;

const ParagraphImageFullWidth = ({ type, content }: IProps) => {
  const imgRel = content.relationships;
  const image = imgRel && imgRel.field_image;

  if (!image) {
    return null;
  }

  return (
    <ParagraphImageFullWidthWrapper
      className="paragraph-full-width-image"
      type={type}
    >
      <DynamicImage
        data={image}
        alt={content.field_image.alt}
      />
    </ParagraphImageFullWidthWrapper>
  );
};

export default ParagraphImageFullWidth;
